const EDGE_EPSILON_PX = 2;

export type CarouselEdgeMetrics = {
  isBeginning: boolean;
  isEnd: boolean;
  isLocked: boolean;
  translate: number;
  maxTranslate: () => number;
  minTranslate: () => number;
};

export function getCarouselEdgeState(metrics: CarouselEdgeMetrics) {
  const atBeginning =
    metrics.isLocked || metrics.isBeginning || Math.abs(metrics.translate - metrics.minTranslate()) <= EDGE_EPSILON_PX;
  const atEnd =
    metrics.isLocked || metrics.isEnd || Math.abs(metrics.maxTranslate() - metrics.translate) <= EDGE_EPSILON_PX;

  return { isBeginning: atBeginning, isEnd: atEnd };
}
